export default "{\n    \"confirmButtonLabel\": \"Confirm\",\n    \"cancelButtonLabel\": \"Cancel\"\n}\n"